

export const columns=[    
       { 
        field: "ItemCode", 
        header: "Item Code",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"ItemCode")}  className="">          
                <p className="w-[6rem]" >
                {row?.ItemCode||""}
                </p>
              </div>
            </>
          ),
       },   
       
       { 
        field: "ItemDescription", 
        header: "Item Description",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"ItemDescription")}  className="">          
                <p className="w-[6rem]" >
                {row?.ItemDescription?.name||""}
                </p>
              </div>
            </>
          ),
       },      
       { 
        field: "StockOnQuantity", 
        header: "Stock On Quantity",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"StockOnQuantity")}  className="">          
                <p className="w-[6rem]" >
                {row?.StockOnQuantity||""}
                </p>
              </div>
            </>
          ),
       },
       { 
        field: "Unit", 
        header: "Unit",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"Unit")}  className="">          
                <p className="w-[6rem]" >
                {row?.Unit||""}
                </p>
              </div>
            </>
          ),
       },
      
     
      //  { 
      //   field: "permissions", 
      //   header: "permissions",
      //   accessor: (row,handleCellClick) => (
      //       <>
      //         <div  onClick={()=>handleCellClick(row,"permissions")}  className="">  
      //             <form className="w-[15rem] flex gap-2">
                        
      //                   {row?.permissions && row?.permissions?.length && row?.permissions?.map((item)=><div >
      //                     <span className="flex gap-2">
      //                       {item?.permissionName}
      //                      <Checkbox value={item?.permissionName} onChange={e => console.log(e)} checked={true}></Checkbox>
      //                     </span>
      //                   </div>)}
      //             </form>
      //         </div>
      //       </>
      //     ), 
      //  },
      //  { 
      //   field: "active", 
      //   header: "Active",
      //   accessor: (row,handleCellClick) => (
      //       <>
      //         <div  onClick={()=>handleCellClick(row,"active")}  className="">          
      //           <p className="w-[6rem]">                    
      //            <Badge
      //             className="w-[6rem]"
      //             severity={
      //               row?.active === true
      //                 ? "success"
      //                 : "danger"
      //             }
      //             value={row?.active?"Enabled":"Disabled"}
      //           ></Badge>          
      //           </p>
      //         </div>
      //       </>
      //     ), 
      //  },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};